unit uHttpHelper;

interface

uses
  WEBLib.REST, WEBLib.JSON, WEBLib.JsonData, JS, Web, WEBLib.Storage, uGlobal;

const
  HTTP_OK=200;
  HTTP_CREATED=201;
  HTTP_ACCEPTED=202;
  HTTP_NO_CONTENT=204;
  HTTP_MOVED_PERMANENTLY=301;
  HTTP_FOUND=302;
  HTTP_SEE_OTHER=303;
  HTTP_NOT_MODIFIED=304;
  HTTP_BADREQUEST=400;
  HTTP_UNAUTHORIZED=401;
  HTTP_FORBIDDEN=403;
  HTTP_NOTFOUND=404;
  HTTP_METHOD_NOT_ALLOWED=405;
  HTTP_CONFLICT=409;
  HTTP_GONE=410;
  HTTP_INTERNALSERVERERROR=500;
  HTTP_NOT_IMPLEMENTED=501;
  HTTP_BAD_GATEWAY=502;
  HTTP_SERVICE_UNAVAILABLE=503;

type
  THTTPHelper = class
    public
      [async]
      class function SendRequest(URL: string; cmd: THTTPCommand; content: string; var jo: TJSONObject): integer; async;  static;
  end;

implementation

{ THTTPHelper }

class function THTTPHelper.SendRequest(URL: string; cmd: THTTPCommand;
  content: string; var jo: TJSONObject): integer;
var
  req: THttpRequest;
  respreq: TJSXMLHttpRequest;
  ls: TLocalStorage;
  accessToken, refreshToken: string;
  jop: TJSONObject;
  jvAccessToken, jvRefreshToken, jvExpiresIn: TJSONValue;
begin
  //Allgemeine Funktion um einen HTTPRequest zu senden, hier wird auch
  //401 UNAUTHORIZED behandelt u. ggf. neuer AccessToken per RefreshToken angefragt.

  ls := TLocalStorage.Create(nil);
  accessToken := ls.GetValue('accesstoken');
  refreshToken := ls.GetValue('refreshtoken');
  ls.free;

  req := THttpRequest.Create(nil);
  req.URL := URL;
  req.Command := cmd;
  //was machen bei Get?
  if (cmd = httpPOST) then
    req.PostData := content;

  req.Headers.Values['Authorization'] := 'Bearer ' + accessToken;
  respreq := await(TJSXMLHttpRequest, req.Perform());
  result := respreq.Status;
  if (respreq.Status = HTTP_OK) then
  begin
    jo := TJSONObject(TJSONObject.ParseJSONValue(string(respreq.response)));

  end else if (respreq.Status = HTTP_BADREQUEST) then
  begin
    jo := TJSONObject(TJSONObject.ParseJSONValue(string(respreq.response)));

  end else if (respreq.Status = HTTP_UNAUTHORIZED) then
  begin
    //wenn ich einen RefreshToken habe, dann versuch ich nen neuen AccessToken
    //anzufragen
    if (refreshToken <> '') then
    begin
      jo := TJSONObject.Create;
      jo.AddPair('refresh_token', refreshToken);
//      req.free;
//      req := TWebHttpRequest.Create(nil);
      req.Headers.Clear;
      req.PostData := jo.ToJSON;
      req.Command := httpPOST;
      req.URL := F1BET_SERVER + '/refresh/';

      respreq := await(TJSXMLHttpRequest, req.Perform());

      if (respreq.Status = HTTP_OK) then
      begin
        jop := TJSONObject(TJSONObject.ParseJSONValue(string(respreq.response)));

        //Nun neuen Access-Token und Refresh-Token auslesen
        jvAccessToken := jop.GetValue('accesstoken');
        jvRefreshToken := jop.GetValue('refreshtoken');
        jvExpiresIn := jop.GetValue('expires_in');
        if not assigned(jvAccessToken) or not assigned(jvRefreshToken) or not assigned(jvExpiresIn) then
          exit;
        ls := TLocalStorage.Create(nil);
        ls.SetValue('accesstoken', jvAccessToken.Value);
        ls.SetValue('refreshtoken', jvRefreshToken.Value);
        ls.SetValue('expires_in', jvExpiresIn.Value);
        ls.free;

        //Ursprüngliche Anfrage nochmal stellen
        req.Headers.Clear;
        req.Headers.Values['Authorization'] := 'Bearer ' + jvAccessToken.Value;
        req.URL := URL;
        req.Command := cmd;
        if (cmd = httpPOST) then
          req.PostData := content
        else
          req.PostData := '';

        respreq := await(TJSXMLHttpRequest, req.Perform());
        result := respreq.Status;
        if (respreq.Status = HTTP_OK) then
        begin
          jo := TJSONObject(TJSONObject.ParseJSONValue(string(respreq.response)));
        end;
        req.free;
        jvAccessToken.free;
        jvRefreshToken.free;
        jvExpiresIn.free;
      end;

    end;


  end;



end;

end.
